import telegram from '../images/telegram.png';
import discord from '../images/discord.png';
import twiter from '../images/twitter.png';

function Header() {
  return (
    <div className="App">
      <header className="App-header"> 
          <div className='header-nav'>
                  <h5 className='toptext'> <b>Follow &nbsp;us&nbsp; on :</b></h5>
                  <a className='header-item'  href='https://twitter.com/SolRoboNFTS'>
                      <img src={twiter} className='header-image'  alt='unable to load'  />
                  </a>
                  <a className='header-item'  href='https://discord.gg/qqBEtrKzux'>
                      <img src={discord} className='header-image'  alt='unable to load'  />
                  </a>
                  <a className='header-item'  href='https://t.me/SolroboAN'>
                      <img src={telegram} className='header-image'   alt='unable to load' />
                  </a>
          </div>
      </header>

    </div>
  );
}

export default Header;